import React, { Fragment } from 'react'
import cx from 'classnames'

import styles from './Table.module.css'

import ArrowDown from './arrow-down-s-fill.svg'
import ArrowUp from './arrow-up-s-fill.svg'

const Table = ({ className, ...rest }) => {
  return <table role='table' className={cx(styles.Table, className)} {...rest} />
}

export const TableHead = ({ className, ...rest }) => {
  return <thead className={cx(styles.TableHead, className)} {...rest} />
}

export const TableBody = ({ className, ...rest }) => {
  return <tbody className={cx(styles.TableBody, className)} {...rest} />
}

export const TableRow = ({ className, clickable, ...rest }) => {
  return <tr role='row' className={cx(styles.TableRow, { [styles.ClickableRow]: clickable }, className)} {...rest} />
}

export const Th = ({ className, isOption = false, children, isSorted, isSortedDesc, ...rest }) => {
  if (isOption) {
    return <th role='columnheader' className={cx(styles.Th, styles.ThOptions, className)} {...rest} />
  }

  return (
    <th role='columnheader' className={cx(styles.Th, { [styles.Pointer]: isSorted }, className)} {...rest}>
      {children}{' '}
      {isSorted && (
        <Fragment>
          {isSortedDesc && <ArrowDown height='16' />}
          {!isSortedDesc && <ArrowUp height='16' />}
        </Fragment>
      )}
    </th>
  )
}

export const Td = ({ className, ...rest }) => {
  return <td role='cell' className={cx(styles.Td, className)} {...rest} />
}

export const TableActions = ({ className, ...rest }) => {
  return <div className={cx(styles.TableActions, className)} {...rest} />
}

export default Table
